/**
 * Hats (the lobby ADR): what the gardener wears on its head, always as part of a head (`HEADS`, ADR-0112: a hat is
 * never picked on its own). The first five recolour the straw of the gardener's sun hat (the art's y Y U e t pixels;
 * assets/src/gardener/hats.ts has the palettes); the team colour stays on the band, bib and legs. Then headwear of its
 * own (ADR-0089: a conical straw hat, a durag, a turban) and the sets' heads (ADR-0112: the gnome's cap, the
 * beekeeper's hat, the space helmet, the pumpkin head), the seasons' (ADR-0123: the reaper's hood) and the mythic sets'
 * (ADR-0160: a burning skull, a fox mask, a black star, a storm cloud), keyed like their set. A hat on the wire is its
 * index here: append, never insert.
 */
export const HATS = {
  straw: { name: 'Straw hat' },
  mint: { name: 'Mint' },
  lavender: { name: 'Lavender' },
  midnight: { name: 'Midnight' },
  golden: { name: 'Golden' },
  conical: { name: 'Conical hat' },
  durag: { name: 'Durag' },
  turban: { name: 'Turban' },
  gnome: { name: 'Gnome cap' },
  beekeeper: { name: 'Beekeeper hat' },
  astronaut: { name: 'Space helmet' },
  pumpkin: { name: 'Pumpkin head' },
  // A season's head (ADR-0123): only the pass gives it, never sold.
  reaper: { name: 'Reaper hood' },
  // The Creator Program's head (ADR-0138, content `PROGRAM_ITEMS`): only its milestones give it, never sold.
  creator: { name: 'Creator cap' },
  // The mythic sets' heads (ADR-0160), in preview (content `SETS`): sold only once an admin releases them.
  inferno: { name: 'Burning skull' },
  kitsune: { name: 'Fox mask' },
  voidwalker: { name: 'Black star' },
  tempest: { name: 'Storm cloud' },
  glacier: { name: 'Ice crown' },
  angler: { name: 'Diving helm' },
  jester: { name: 'Jester mask' },
  plague: { name: 'Plague mask' },
  chronomancer: { name: 'Clock face' },
  glitch: { name: 'Visor' },
  disco: { name: 'Mirror ball' },
  origami: { name: 'Crane kabuto' },
  ooze: { name: 'Goo dome' },
  barnstormer: { name: 'Flying helmet' },
  pirate: { name: 'Tricorn' },
  magician: { name: 'Top hat' },
  chef: { name: "Chef's toque" },
  knight: { name: 'Great helm' },
  sheriff: { name: 'Stetson' },
  luchador: { name: 'Lucha mask' },
} as const satisfies Record<string, { name: string }>;

export type HatKey = keyof typeof HATS;

/** Every hat; a hat on the wire is its index here. */
export const HAT_KEYS = Object.keys(HATS) as HatKey[];

export const isHatKey = (key: string): key is HatKey => Object.hasOwn(HATS, key);
